import React, { useState, useEffect } from 'react';
import { useGetPaymentMethodsMutation } from '../../redux/services/paymentApi';
import SavedCardDisplay from '../../components/stripeCard/SavedCardDisplay';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Spinner, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { setEditing, setPaymentMethods } from '../../redux/slice/paymentSlice';
import CenteredToast from '../../components/centeredToast/centeredToast';
import { useSendPaymentMutation } from '../../redux/services/paymentApi';
import NavigationWrapper from '../../components/sessionNavigation/navigationWrapper';
import { useActivateSessionMutation } from '../../redux/services/sessionApi';
import SessionStarted from '../sessionProfileSetup/sessionStarted';
const SelectPaymentMethod = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'selectPaymentMethod' });
  const [showAlert, setShowAlert] = useState(null)
  const navigate = useNavigate();
  const [getPaymentMethods, { data, isLoading, error, refetch }] = useGetPaymentMethodsMutation();
  const paymentMethods = useSelector((state) => state?.payment?.paymentMethods);
  const tanProfile = useSelector((state) => state?.tanProfile)
  const session = useSelector((state) => state?.session)
  const sessionStarted = useSelector((state) => state?.session?.sessionSendCompleted?.sessionReady)
  const auth = useSelector((state) => state?.auth)
  const [activateSession, {isLoading: isActivating, isSuccess: activatedSession, data: activationData}] = useActivateSessionMutation()
  const [showLoading, setShowLoading] = useState(false)
  const [sendPayment, {
    isLoading: isPaying,
    isSuccess: paid,
    data: paymentData,
    error: paymentError
  }] = useSendPaymentMutation();
  const dispatch = useDispatch()
  useEffect(() => {
    getPaymentMethods()
  },[])
  useEffect(() => {
    if(paid){
      console.log(paymentData)
      activateSession({
        sessionId: session?.confirmedSession?.id,
        sid: session?.session?.sid
      }).unwrap()
    }
  }, [paid])
  useEffect(() => {
    if(sessionStarted){
      navigate("/session/sessionStarted")
    }
  },[sessionStarted])
  console.log(tanProfile)
  console.log(auth)
  console.log(session)
  let total = 0
  for (let index in tanProfile?.selectedProfile?.session_component) {


    let item = tanProfile?.selectedProfile?.session_component[index]
    let salonData = tanProfile.scannedBoothComponents.find((comp) => comp.id === item.component_id)?.component_values.find((cVal) => cVal.id === item.component_value_id)
    let price = salonData?.booth_component_pricing[0] ? salonData?.booth_component_pricing[0]?.msrp : salonData?.price 

    total += price
  }

  return (
    <NavigationWrapper hideNext={true} >
      <Container className="mt-4">
        {paymentError && <Alert variant="danger" className="text-center">
            {t("payment.error", "Payment declined ")} {paymentError.message}
          </Alert>}
        <h1 className="text-center mb-4">{t("total", "Total: ${{total}}", { total: total })}</h1>
        {isLoading || showLoading ? (
          <div className="text-center my-4">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">{t("loading", "Loading...")}</span>
            </Spinner>
          </div>
        ) : error ? (
          <Alert variant="danger" className="text-center">
            {t("error", "Error loading payment methods:")} {error.message}
          </Alert>
        ) : (
          <><Row className="justify-content-center">
            {paymentMethods && paymentMethods.length > 0 ? (
              paymentMethods.map((method, index) => (
                <Col style={{ width: "fit-content" }} xs={12} sm={8} md={6} lg={4} key={index} className="mb-4" onClick={() => {
                  // dispatch(setEditing(method))
                  // navigate("addPaymentMethod")
                }}>
                  <SavedCardDisplay card={method} select={() => {
                    setShowAlert(method)
                  }} />
                </Col>
              ))
            ) : (
              <Col xs={12} className="text-center">
                <p>{t("noCards", "No saved cards available.")}</p>
              </Col>
            )}
          </Row>
            <Row>
              {/* Add New Card Button */}
              <Col style={{ width: "fit-content" }} xs={12} sm={8} md={6} lg={4} key={-2} className="mb-4">
                <Button variant="primary" onClick={() => navigate('/addPaymentMethod')}>
                  {t("addCardButton", "+ Add New Card")}
                </Button>
              </Col>
            </Row></>
        )}
        {showAlert && <CenteredToast
          show={showAlert}
          onHide={(() => { setShowAlert(false) })}
          onAccept={(instance) => {
            let body = {
                  "token": showAlert.id,
                  // "source": "app",
                  "amount": Math.round(total * 100).toString(),
                  "payment_method": "card",
                  "venue_id": tanProfile?.scannedBoothData?.venue?.id,
                  "booth_id": tanProfile?.scannedBoothData?.id,
                  "session_id": session?.confirmedSession?.id,
                  "venue_stripe_account_id": tanProfile?.scannedBoothData?.venue?.stripe_account_id,
                  "stripe_customer": auth?.user?.stripe_id
              }
            let valid = true;
            for(let item in body){
              if(!body[item]){
                valid = false
              }
            } 
            if (valid) {
              // deletePaymentMethod(showAlert.id)
              setShowLoading(true)
                sendPayment(body).unwrap().catch((err) => {
                  console.log(err)
                  setShowLoading(false)
                })
            }
          }}
          onCancel={() => { console.log("Cancel") }}
          title={t("alert.title", "Choose card")}
          body={t("alert.body", "Pay ${{price}} with {{card}} ending in {{name}}?", { name: showAlert.last4, card: showAlert.brand, price: total })}
          acceptButtonText={t("alert.button", "Pay")}
          closeOnOverlayClick={true}
        ></CenteredToast>}
      </Container>
    </NavigationWrapper>
  );
};

export default SelectPaymentMethod;
